import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '@cdn/identity';

/**
 * A person coming back from a page of Beyond Accounts the family bar's profile menu opened (`?returned=accounts`)
 * may have joined, left or created an organization there: their standing is read again once, and the marker
 * leaves the address so a reload or a shared link does not read it again. A standing that cannot be read now
 * keeps the one the page has; the service still decides every request.
 */
export function Returned() {
	const session = useSession();
	const navigate = useNavigate();
	const { pathname, search, hash } = useLocation();
	const returned = new URLSearchParams(search).get('returned') === 'accounts';

	useEffect(() => {
		if (!returned) return;
		const address = new URLSearchParams(search);
		address.delete('returned');
		const rest = address.toString();
		navigate(`${pathname}${rest ? `?${rest}` : ''}${hash}`, { replace: true });
		void session.refresh().catch(() => undefined);
	}, [returned, pathname, search, hash, navigate, session]);

	return null;
}
